import { LOADING, MESSAGE, MESSAGE_RESERVATION } from './constants';

const commonReducer = (state, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.loading
      }
    case MESSAGE:
      return {
        ...state,
        message: action.message
      }
    case MESSAGE_RESERVATION:
      return {
        ...state,
        messageReservation: action.messageReservation
      }
    default:
      return state
  }
}

export default commonReducer;
